import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
// import useSidebarToggle from "../hooks/useSidebarToggle";
import config from "../../config";
import $ from "jquery";
import Swal from "sweetalert2";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { IoMdInformationCircle } from "react-icons/io";
import { ContextBoard } from "../../context/ContextBoard";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import ChecklistPdfButton from "./ChecklistPdfButton";
import { getSessionData } from "../../cache";

function TotalRegistration() {
  const {
    setCandidateid,
    setMode,
    setDivyangcode,
    setCastecode,
    setRegistrationNumber,
    setSessionCode,
    setModeex,
  } = useContext(ContextBoard);
  const navigate = useNavigate();
  // useSidebarToggle();

  const [isLoading, setIsLoading] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const iframeRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const token1 = sessionStorage.getItem("tokenclassix");

  const handleEdit = (id, category, divyang, caste, reg_no, regsession) => {
    setCandidateid(id);
    // setMode("edit");

    if (category === "EX-REGULAR") {
      setModeex("edit");
      setDivyangcode(divyang);
      setCastecode(caste);
      setRegistrationNumber(reg_no);
      setSessionCode(regsession);
      navigate(`/class-ix-add-ex-regular-student`);
    } else {
      setMode("edit");
      navigate(`/class-ix-regular-student`);
    }
  };

  useEffect(() => {
    setCandidateid("");
    setMode("");
    setCastecode("");
    setDivyangcode("");
  }, []);

  useEffect(() => {
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);
  const [EndDate, setEndDate] = useState("");

  useEffect(() => {
    const token = sessionStorage.getItem("tokenclassix");
    const fetchStudents = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${config.API_BASE_URL}/FetchTotalRegistrationDataBySchool_CL9`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({
            //   schooL_CODE: schoolCode,
            // }),
          }
        );

        if (!response.ok) {
          // Swal.fire({
          //   icon: "warning",
          //   title: "Data not found!",
          // });
          return;
        }

        const data = await response.json();
        // console.log("Total Registration Data:", data);
        setStudentData(data.data.studentRegistration_list || []);
        // console.log(data.data["student-data"] || []);
      } catch (error) {
        console.error("Error fetching students:", error);
      } finally {
        setIsLoading(false);
      }
    };
    const enddate = getSessionData("EndDate");
    setEndDate(enddate);
    fetchStudents();
  }, []);

  const filteredStudents = studentData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.includes(query) ||
      student.actuaL_CATEGORY?.toLowerCase().includes(query) ||
      student.checklisT_STATUS?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query) ||
      student.gender?.toLowerCase().includes(query)
    );
  });

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      // Only include candidates whose DOC_STATUS is "YES"
      const validCandidates = filteredStudents
        .filter((student) => student.doC_STATUS === "YES")
        .map((student) => student.candidatE_ID);
      setSelectedCandidates(validCandidates);
    } else {
      setSelectedCandidates([]);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedCandidates((prev) => {
      const newSelectedCandidates = prev.includes(id)
        ? prev.filter((cid) => cid !== id)
        : [...prev, id];

      const visibleValidIds = filteredStudents
        .filter((s) => s.doC_STATUS === "YES")
        .map((s) => s.candidatE_ID);

      const allVisibleSelected = visibleValidIds.every((id) =>
        newSelectedCandidates.includes(id)
      );
      setSelectAll(allVisibleSelected);
      return newSelectedCandidates;
    });
  };

  const generateChecklistPdf = async () => {
    try {
      setIsPdfGenerating(true);
      const response = await fetch(
        `${config.API_BASE_URL}/GenerateChecklistPdf`,
        //"https://localhost:7197/GenerateChecklistPdf",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token1}`,
          },
          body: JSON.stringify({
            CANDIDATE_ID: selectedCandidates.join(","),
            districtcode: sessionStorage.getItem("district"),
          }),
        }
      );

      if (response.ok) {
        const blob = await response.blob(); // ← Correct way to get blob
        const fileURL = URL.createObjectURL(blob);

        // const uniqueWindowName = `ChecklistPopup_${Date.now()}`;
        // const windowFeatures =
        //   "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=800,height=600,left=100,top=100";

        window.open(fileURL, "_blank");

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setIsPdfGenerating(false);
        const errorText = await response.text();
        alert("PDF generation failed: " + errorText);
      }
    } catch (error) {
      setIsPdfGenerating(false);
      console.error("Checklist PDF error:", error);
      alert("PDF generation failed. Please try again.");
    }
  };

  const handleViewRemarks = (remarks) => {
    setSelectedRemarks(remarks || "No remarks available.");
    setShowModal(true);
  };
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };
  return (
    <div class="container-scroller">
      {isLoading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div class="container-fluid page-body-wrapper">
        <Sidebar />
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 mb-1">
                <section class="content-header">
                  <h1>
                    <i class="fa fa-user-plus"></i>&nbsp; Total Registration
                  </h1>
                  <ol class="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          navigate("/class-ix-dashboard");
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: "-4px" }}
                        >
                          <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                        </svg>{" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li class="active"> Total Registration</li>
                  </ol>
                  <h3></h3>
                </section>
              </div>
            </div>
            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12 personal-details">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <div style={{ width: "250px" }}>
                          <select
                            id="rowsPerPage"
                            className="form-select form-select-sm"
                            value={perPage}
                            onChange={handlePerPageChange}
                            style={{
                              width: "80px", // or adjust as needed (80–120px)
                              paddingRight: "2rem", // ensures space for the dropdown arrow
                            }}
                          >
                            {[10, 20, 50, 100, 500].map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* Search on the right */}
                      <div style={{ width: "200px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>

                    {isLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className="table-info">
                              <th>
                                <input
                                  type="checkbox"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                />
                              </th>
                              <th>Sl. No</th>
                              <th>Checklist Status</th>
                              <th>Category</th>
                              <th>DEO Status</th>
                              <th>Name of Candidate</th>
                              <th>Gender</th>
                              <th style={{ width: "110px" }}>Date of Birth</th>
                              <th>Father's Name</th>
                              <th>Mother's Name</th>
                              <th>Aadhaar Number</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No data found.
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    {row.doC_STATUS === "YES" ? (
                                      <input
                                        type="checkbox"
                                        checked={selectedCandidates.includes(
                                          row.candidatE_ID
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(row.candidatE_ID)
                                        }
                                      />
                                    ) : (
                                      <>
                                        <IoMdInformationCircle
                                          data-tooltip-id={`tooltip-${row.candidatE_ID}`}
                                          data-tooltip-content="Documents not submitted"
                                          style={{
                                            fontSize: "18px",
                                            cursor: "pointer",
                                          }}
                                          className="text-danger"
                                        />
                                        <Tooltip
                                          id={`tooltip-${row.candidatE_ID}`}
                                          place="right"
                                          style={{
                                            backgroundColor: "#000",
                                            color: "#fff",
                                            border: "1px solid #333",
                                            borderRadius: "4px",
                                            padding: "6px 10px",
                                            fontSize: "13px",
                                          }}
                                        />
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {(currentPage - 1) * perPage + index + 1}
                                  </td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        row.checklisT_STATUS === "PRINTED"
                                          ? "bg-success border border-success"
                                          : "bg-danger border border-danger"
                                      }`}
                                      style={{ fontSize: "12px" }}
                                    >
                                      {row.checklisT_STATUS === "PRINTED" ? (
                                        <>
                                          <i className="fa fa-check"></i>{" "}
                                          {/* or use emoji: ✔️ */}
                                          {row.checklisT_STATUS}
                                        </>
                                      ) : (
                                        <>
                                          <i className="fa fa-clock"></i>{" "}
                                          {/* or use emoji: ⏳ */}
                                          {row.checklisT_STATUS}
                                        </>
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    {row.actuaL_CATEGORY === "E"
                                      ? "Ex-Regular"
                                      : row.actuaL_CATEGORY}
                                  </td>
                                  <td>
                                    {row.deO_STATUS === "REJECTED" ? (
                                      <button
                                        className="btn btn-sm btn-danger"
                                        style={{ fontSize: "12px" }}
                                        onClick={() =>
                                          handleViewRemarks(
                                            row.remarkS_REJECTED
                                          )
                                        }
                                      >
                                        <i className="fa fa-times"></i>&nbsp;
                                        {row.deO_STATUS}
                                      </button>
                                    ) : row.deO_STATUS === "PENDING" ? (
                                      <span
                                        className="badge bg-warning border border-warning"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {row.deO_STATUS}
                                      </span>
                                    ) : row.deO_STATUS === "APPROVED" ? (
                                      <span
                                        className="badge bg-success border border-success"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {row.deO_STATUS}
                                      </span>
                                    ) : row.deO_STATUS === "EX-APPROVED" ? (
                                      ""
                                    ) : (
                                      <span
                                        className="badge bg-secondary border border-secondary"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {row.deO_STATUS}
                                      </span>
                                    )}
                                  </td>
                                  <td>{row.candidatE_NAME}</td>
                                  <td>{row.gender}</td>
                                  <td>{row.dob}</td>

                                  <td>{row.fatheR_NAME}</td>
                                  <td>{row.motheR_NAME}</td>
                                  <td>
                                    {row.aadhaR_CARD
                                      ? "********" + row.aadhaR_CARD.slice(-4)
                                      : ""}
                                  </td>
                                  <td>
                                    {parseDate(currentDate) >=
                                    parseDate(EndDate)
                                      ? ""
                                      : row.deO_STATUS !== "PENDING" &&
                                        row.deO_STATUS !== "APPROVED" &&
                                        row.challaN_STATUS !== "GENERATED" &&
                                        row.deO_STATUS !== "EX-APPROVED" &&
                                        !(
                                          row.checklisT_STATUS ===
                                            "GENERATED" &&
                                          (!row.deO_STATUS ||
                                            row.deO_STATUS.trim() === "")
                                        ) && (
                                          <a
                                            className="btn btn-primary btn-sm text-white"
                                            onClick={() =>
                                              handleEdit(
                                                row.candidatE_ID,
                                                row.actuaL_CATEGORY,
                                                row.divyang,
                                                row.cast,
                                                row.refferencE_NO,
                                                row.registratioN_SESSION
                                              )
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            <i className="fa fa-edit"></i> Edit
                                          </a>
                                        )}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="mt-3">
                      {selectedCandidates.length !== 0 ? (
                        <ChecklistPdfButton
                          selectedCandidates={selectedCandidates}
                        />
                      ) : (
                        <button className="btn btn-success btn-sm" disabled>
                          Print Checklist
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AnimatePresence>
            {showModal && (
              <motion.div
                className="modal-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1050,
                }}
              >
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.8, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="modal-content p-4 bg-white rounded"
                  style={{ width: "400px", position: "relative" }}
                >
                  <h5 className="mb-3">DEO Rejection Remarks</h5>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={selectedRemarks}
                    readOnly
                  />
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default TotalRegistration;
